import { useEffect, useState } from 'react';
import useFetch from 'utils/hooks/useFetch';
import { ApiResponseSuccess, EmptyString } from 'utils/Constant';
import { ApiLogin } from 'utils/constants/api';
import FailModal from '../components/modal/FailModal';
import LoadingModal from 'components/modal/LoadingModal';
import PadelPortLogo from '../assets/images/PadelPortLogo.png'

export default function Login() {
	const { fetch: login } = useFetch(ApiLogin)

	const[username, setUsername] = useState(EmptyString)
	const[password, setPassword] = useState(EmptyString)
	const[loginMessage, setLoginMessage] = useState()
	const[isLoginButtonDisabled, setIsLoginButtonDisabled] = useState(true)
	const[isShowPassword, setIsShowPassword] = useState(false)

	const loginBtnClick = () => {
		setLoading({isOpen: true})

		fLogin().then(() => {
			setLoading({isOpen: false})
		})
	}
	// Modal
	const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({ isOpen: false })

	useEffect(() => {
		if(username !== EmptyString && password !== EmptyString){
			setIsLoginButtonDisabled(false)
		}else{
			setIsLoginButtonDisabled(true)
		}
	}, [username, password])

	async function fLogin(){
		await login({
			data: {
				username: username,
				password: password
			}
		}).then((response) => {
			if(response !== null){
				if(response.status === ApiResponseSuccess){
					if(response.message !== EmptyString){
						setLoginMessage(response.message)
					}else{
						let data = response.data

						localStorage.setItem("Id", String(data.userId))
						localStorage.setItem("Username", data.username)
						localStorage.setItem("Name", data.fullName)
						localStorage.setItem("Token", data.token)
						localStorage.setItem("IsAdmin", data.isAdmin === true ? "1" : "0")
						
						window.location.assign('/')
					}
				}else{
					setFailModal({
						isOpen: true,
						data: {
							onSuccess: async () => {
								setFailModal({isOpen: false})
							}
						},
						message: response.message
					})
				}
			}else{
				setFailModal({
					isOpen: true,
					data: {
						onSuccess: async () => {
							setFailModal({isOpen: false})
						}
					},
					message: "Server error"
				})
			}
		})
	}

	function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			setLoading({ isOpen: true })

			fLogin().then(() => {
				setLoading({ isOpen: false })
			})
		}
	}

	return (
		<div className='w-full h-screen overflow-hidden flex flex-col justify-center items-center gap-8 bg-black'>
			<div className='bg-white h-screen sm:h-auto sm:py-12 sm:rounded-lg px-12 flex flex-col sm:flex-row items-center justify-center gap-12'>
				{/* Login title */}
				<div className='flex flex-col gap-4 items-center justify-center sm:bg-[#081f32] sm:h-full rounded-xl'>
					<img src={PadelPortLogo} className='w-44' alt="Logo" /> 
				</div>
				
				{/* Login form */}
				<div className='flex flex-col bg-blue w-80 gap-2'>					
					<span className='text-3xl font-semibold mb-3'>Login</span>

					<div>
						<h1 className=''>Username</h1>
						<input className='seq-input' value={username} onChange={(e) => {setUsername(e.target.value)}} onKeyDown={(e) => { fEnterKeyDown(e) }} />
					</div>
					
					<div>
						<h1 className=''>Password</h1>
						<input className='seq-input' value={password} onChange={(e) => {setPassword(e.target.value)}} onKeyDown={(e) => { fEnterKeyDown(e) }} type={isShowPassword ? 'text' : 'password'} />
					</div>

					<div className='flex items-center gap-2'>
						<input className='w-4' value={isShowPassword} checked={isShowPassword} onClick={() => { setIsShowPassword(!isShowPassword) }} type='checkbox' />
						<span>Show password</span>
					</div>

					<div>
						<span className='text-red-500'>{loginMessage}</span>
					</div>

					<button className={`login-button mt-4 ${isLoginButtonDisabled ? 'bg-app-light-grey' : 'bg-app-matte-black'}`} disabled={isLoginButtonDisabled} onClick={loginBtnClick} >Login</button>
				</div>
			</div>
			

			{/* Modal */}
			{failModal.isOpen && (
				<FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} />
			)}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
		</div>
	);
}
